<template>
  <ListViewBanner>Settings</ListViewBanner>

  <AppContainer>
    <AppTable>
      <AppTableHeader>
        <th>Key</th>
        <th>Values</th>

        <th class="w-[120px]">
          <span class="sr-only">Actions</span>
        </th>
      </AppTableHeader>

      <AppTableBody
        :loading="loading"
        :no-results="!settings.length"
        :colspan="3"
      >
        <template v-if="settings.length">
          <tr
            v-for="setting in settings"
            :key="setting.id"
            class="overflow-visible"
          >
            <td>{{ setting.key }}</td>

            <td>{{ setting.values }}</td>

            <td class="text-end">
              <RouterLink
                class="btn btn-outline btn-secondary !py-1 !px-4"
                :to="{ name: 'app_setting_edit', params: { setting: setting.id } }"
              >
                Edit
              </RouterLink>
            </td>
          </tr>
        </template>
      </AppTableBody>
    </AppTable>
  </AppContainer>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { ref } from 'vue';

import { AppContainer } from '@/components/app';
import { ListViewBanner } from '@/components/banners';
import { AppTable, AppTableBody, AppTableHeader } from '@/components/tables';

import { useHttp } from '@/composables';

const loading = ref();
const settings = ref([]);

const loadSettings = async () => {
  loading.value = true;
  settings.value = [];

  const response = await useHttp().get('/settings');

  if (response.statusCode === HttpStatusCode.Ok) {
    settings.value = response.data.items;
  }

  loading.value = false;
};

loadSettings();

</script>
